import axios from 'axios';
import API from "../config/API";
import siteSetting from "../config/env";

// Function to generate common headers
function getCommonHeaders() {
    const accessToken = localStorage.getItem('accessToken');
    return {
        'Content-Type': 'application/json',
        'Authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
}

// Function to add common parameters
function addCommonParams(params) {
    return {
        ...params,
        clientId: siteSetting.api_clientId,
        clientSecret: siteSetting.api_clientSecret
    };
}

export const formService = {
    createForm,
    editForm,
    deleteForm,
    viewForm,
    listForms,
    formShareSetting,
    sendForm,
    submitForm,
    listSubmissions,
    getBookingSubmissions,
    removeSubmission,
    viewSubmission,
    attachToBooking,
    getBookingForms,
    publicViewForm,
    publicSubmitForm,
    uploadHeroImage,
    deleteHeroImage,
    setHeroImage,
};

function createForm(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_CREATE, updatedParams, { headers });
}

function editForm(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_EDIT, updatedParams, { headers });
}

function deleteForm(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_DELETE, updatedParams, { headers });
}

function viewForm(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_VIEW, updatedParams, { headers });
}

function listForms(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_LIST, updatedParams, { headers });
}

function formShareSetting(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SHARE_SETTING, updatedParams, { headers });
}

function sendForm(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SEND, updatedParams, { headers });
}

function submitForm(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SUBMIT, updatedParams, { headers });
}

function listSubmissions(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SUBMISSION_LIST, updatedParams, { headers });
}

function getBookingSubmissions(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SUBMISSION_BOOKING, updatedParams, { headers });
}

function removeSubmission(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SUBMISSION_REMOVE, updatedParams, { headers });
}

function viewSubmission(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SUBMISSION_VIEW, updatedParams, { headers });
}

function attachToBooking(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_ATTACH_BOOKING, updatedParams, { headers });
}

function getBookingForms(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_BOOKING_FORMS, updatedParams, { headers });
}

// Hero image endpoints
function uploadHeroImage(formId, imageFile) {
    const accessToken = localStorage.getItem('accessToken');
    const formData = new FormData();
    formData.append('heroImage', imageFile);
    formData.append('formId', formId);
    formData.append('clientId', siteSetting.api_clientId);
    formData.append('clientSecret', siteSetting.api_clientSecret);
    return axios.post(API.FORM_UPLOAD_HERO_IMAGE, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': "Basic YmV1YXBwOmJldWFwcA==",
            'accessToken': `${accessToken}`
        }
    });
}

function deleteHeroImage(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_DELETE_HERO_IMAGE, updatedParams, { headers });
}

function setHeroImage(params) {
    const headers = getCommonHeaders();
    const updatedParams = addCommonParams(params);
    return axios.post(API.FORM_SET_HERO_IMAGE, updatedParams, { headers });
}

// Public endpoints (no auth required)
function publicViewForm(params) {
    return axios.post(API.FORM_PUBLIC_VIEW, params, {
        headers: { 'Content-Type': 'application/json' }
    });
}

function publicSubmitForm(params) {
    return axios.post(API.FORM_PUBLIC_SUBMIT, params, {
        headers: { 'Content-Type': 'application/json' }
    });
}
